<template>
    <v-dialog v-model="exibeModal" width="900" persistent>
        <v-card>
            <v-card-title
                class="body-2 font-weight-bold primary white--text"
                primary-title>
                Novo Ajuste
                <v-spacer/>
                <v-btn icon small dark @click="fecharModalNovoAjuste">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-form class="az-form-content form py-4 px-4" lazy-validation ref="form">
                <v-row>
                    <v-col>
                        <az-combo-enum
                            v-model="novoAjuste.tipoAjuste"
                            :disabled="!verificaPermissaoEdicao"
                            :class="{desativado:!verificaPermissaoEdicao}"
                            :enum-object="tipoAjuste"
                            :insertNullItem="false"
                            :is-required="true"
                            name="Tipo de Ajuste"
                            placeholder="Selecione"
                            @input="atualizarTipoAjuste"
                            >
                            <template v-slot:label>
                                Tipo de Ajuste
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </az-combo-enum>
                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="patrimonio.numero"
                            label="Nº Patrimônio"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioNumero"
                            placeholder="Informe o número"
                            disabled
                            :error-messages="errors.collect('patrimonioNumero')"/>
                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="patrimonio.descricao"
                            label="Descrição"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="patrimonioDescricao"
                            placeholder=" "
                            disabled
                            :error-messages="errors.collect('patrimonioDescricao')"/>
                    </v-col>

                </v-row>

                <v-row>
                    <v-col>
                        <az-money
                            v-model="patrimonio.valorEntrada"
                            disabled
                            label="Valor Entrada"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'">
                        </az-money>
                    </v-col>

                    <v-col>
                        <az-money
                            v-model="patrimonio.valorBruto"
                            disabled
                            label="Valor bruto"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'">
                        </az-money>
                    </v-col>

                    <v-col>
                        <az-money
                            v-model="patrimonio.valorLiquido"
                            disabled
                            label="Valor Líquido"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            >
                        </az-money>
                    </v-col>

                    <v-col>
                        <v-text-field
                            :value="retornaTextoPeriodoVidaUtil"
                            append-icon="fas fa-calendar"
                            label="Período Licença"
                            v-validate="'required|max:50'"
                            maxlength="50"
                            name="periodoLicenca"
                            placeholder="Data"
                            disabled
                            :error-messages="errors.collect('periodoLicenca')"/>
                    </v-col>
                </v-row>

                <v-row v-if="!ehAjusteValorRecuperavel">
                    <v-col cols="4">
                        <az-money
                            v-model="novoAjuste.valorAcrescido"
                            :event-submit="'blur'"
                            v-validate="'required'"
                            required
                            name="Valor Acrescido"
                            data-vv-as="Valor Acrescido"
                            :error-messages="errors.collect('valorAcrescido')"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            :maxLength="18"
                            @input="atualizarValorAcrescimoInserido($event)">
                            <template v-slot:label>
                                Valor Acrescido (R$)
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </az-money>
                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="novoAjuste.ValorBrutoPosteriorFormatado"
                            required
                            disabled
                            label="Novo Valor Bruto"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                        >
                        </v-text-field>
                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="novoAjuste.valorLiquidoFinalFormatado"
                            required
                            disabled
                            label="Valor Líquido Final"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                            >
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row v-if="ehAjusteValorRecuperavel">
                    <v-col cols="4">
                        <az-money
                            v-model="novoAjuste.valorLiquidoPosterior"
                            :event-submit="'blur'"
                            v-validate="'required'"
                            required
                            name="Novo Valor Líquido"
                            data-vv-as="Novo Valor Líquido"
                            :error-messages="errors.collect('valorLiquidoPosterior')"
                            class="botaoExcluirMoney mb-0"
                            :placeholder="'0,00'"
                            :maxLength="18"
                            @input="atualizarNovoValorLiquidoInserido($event)">
                            <template v-slot:label>
                                Novo Valor Líquido
                                <span class="ml-1 red--text">*</span>
                            </template>
                        </az-money>
                        <div v-if="erroNovoValorLiquido" class="error--text text-caption custom-error-message">{{ erroNovoValorLiquido }}</div>

                    </v-col>

                    <v-col>
                        <v-text-field
                            v-model="novoAjuste.valorBrutoPosteriorFormatado"
                            required
                            disabled
                            label="Novo valor bruto"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="novoAjuste.valorReduzidoFormatado"
                            required
                            disabled
                            label="Valor reduzido"
                            class="botaoExcluirMoney"
                            :placeholder="'0,00'"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="novoAjuste.observacoes"
                            counter="250"
                            auto-grow
                            class="mt-2"
                            rows="2"
                            v-validate="observacaoObrigatoria ? 'required|max:250' : 'max:250'"
                            data-vv-as="observações"
                            name="observacoes"
                            :maxlength="250"
                            type="text"
                            placeholder="Informe a observação."
                            :error-messages="errors.collect('observacoes')">
                            <template v-slot:label>
                                Observações
                                <span v-if="(observacaoObrigatoria && ehAjusteValorRecuperavel)" class="ml-1 red--text">*</span>
                            </template>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-form>

            <v-divider></v-divider>
            <v-card-actions>
                <v-flex class="row pa-3 ma-0">
                    <v-btn color="grey" text outlined width="150" class="text-body-2"
                           @click="fecharModalNovoAjuste">
                        Cancelar
                    </v-btn>
                    <v-spacer/>
                    <v-spacer/>
                    <v-btn
                        v-if="validarCampos"
                        depressed
                        width="150"
                        class="text-body-2" color="primary" :disabled="!verificaPermissaoEdicao || !podeSalvar"
                        @click="salvarNovoAjuste"
                    >
                        Salvar
                    </v-btn>
                    <v-tooltip
                        v-else
                        nudge-top="0"
                        top
                        transition="scale-transition"
                        origin="center center"
                        max-width="300"
                    >
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn v-on="on" disabled depressed width="150" class="text-body-2"
                                       color="primary">
                                    Salvar
                                </v-btn>
                            </div>
                        </template>
                        Preencha todos os campos obrigatórios para salvar o Novo Ajuste.
                    </v-tooltip>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {createNamespacedHelpers, mapActions, mapMutations, mapState} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {actionTypes, mutationTypes} from '@/core/constants'
    import tipoAjuste from '@/core/constants/tipoAjuste'

    const {mapGetters} = createNamespacedHelpers('CamposPersonalizados')

    export default {
        name: 'ModalNovoAjuste',
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                exibeModal: true,
                podeSalvar: true,
                tipoAjuste: tipoAjuste,
                novoAjuste: {
                    tipoAjuste: 'ADICAO_DE_CUSTO_SUBSEQUENTE',
                    valorAcrescido: null,
                    valorLiquidoPosterior: null,
                    valorLiquidoPosteriorFormatado: null,
                    novoValorEntrada: null,
                    valorLiquidoFinal: null,
                    valorLiquidoFinalFormatado: null,
                    ValorBrutoPosterior: null,
                    ValorBrutoPosteriorFormatado: null,
                    valorBrutoPosterior: null,
                    valorBrutoPosteriorFormatado: null,
                    valorReduzido: null,
                    valorReduzidoFormatado: null,
                    observacoes: null
                }
            }
        },

        async mounted(){
            await this.calcularValorLiquidoFinal()
            this.atualizarTipoAjuste()

            this.setAjuste({
                tipoAjuste: 'ADICAO_DE_CUSTO_SUBSEQUENTE'
            })

        },
        computed: {
            ...mapGetters([
                'getObrigatorioCamposPersonalizados'
            ]),

            observacaoObrigatoria() {
                return this.getObrigatorioCamposPersonalizados('observacoes', 'AJUSTE_DE_VALOR') || false
            },
            ...mapState({patrimonio: state => state.patrimonio.patrimonio}),

            ehAjusteValorRecuperavel() {
                return this.novoAjuste.tipoAjuste === 'REDUCAO_AO_VALOR_RECUPERAVEL'
            },

            validarCampos() {
                let validado = false
                if (this.novoAjuste.tipoAjuste === 'ADICAO_DE_CUSTO_SUBSEQUENTE'){
                    validado = this.novoAjuste.valorAcrescido && this.novoAjuste.tipoAjuste
                }

                if (this.novoAjuste.tipoAjuste === 'REDUCAO_AO_VALOR_RECUPERAVEL' && this.observacaoObrigatoria){
                    validado = this.novoAjuste.valorLiquidoPosterior && this.novoAjuste.tipoAjuste && this.novoAjuste.observacoes
                }

                if (this.novoAjuste.tipoAjuste === 'REDUCAO_AO_VALOR_RECUPERAVEL' && !this.observacaoObrigatoria){
                    validado = this.novoAjuste.valorLiquidoPosterior && this.novoAjuste.tipoAjuste
                }

                if (this.novoAjuste.tipoAjuste === 'REDUCAO_AO_VALOR_RECUPERAVEL' && this.erroNovoValorLiquido){
                    validado = false
                }

                return validado


            },
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
            retornaTextoPeriodoVidaUtil() {
                const dataInicio = this.patrimonio.inicioVidaUtil
                const dataFim = this.patrimonio.fimVidaUtil
                return `${this.$options.filters.azDate(dataInicio)} a ${this.$options.filters.azDate(dataFim)}`
            },
            meses() {
                if (this.patrimonio && this.patrimonio.periodoVidaUtil) {
                    return this.patrimonio.periodoVidaUtil.mes
                }
                return 0
            },
            erroNovoValorLiquido() {
                if (this.novoAjuste.tipoAjuste !== 'REDUCAO_AO_VALOR_RECUPERAVEL') return ''
                const v = this.novoAjuste.valorLiquidoPosterior
                const liquidoAtual = this.patrimonio && this.patrimonio.valorLiquido != null ? this.patrimonio.valorLiquido : null
                if (typeof v === 'number') {
                    if (v < 0) return 'O valor não pode ser negativo.'
                    if (v === 0) return 'O valor não pode ser 0,00.'
                    if (liquidoAtual != null && v >= liquidoAtual) return 'O novo valor líquido deve ser menor que o valor líquido atual do bem.'
                }
                return ''
            }
        },
        methods: {
            ...mapActions([
                actionTypes.AJUSTE.CADASTRAR_NOVO_AJUSTE
            ]),
            ...mapMutations([
                mutationTypes.AJUSTE.SET_AJUSTE
            ]),
            fecharModalNovoAjuste() {
                this.podeSalvar = false
                this.$emit('fecharModalAjuste')
            },

            atualizarValorAcrescimoInserido(value){
                this.novoAjuste.valorAcrescido = value
                this.novoAjuste.ValorBrutoPosterior = this.patrimonio.valorBruto + this.novoAjuste.valorAcrescido
                this.novoAjuste.ValorBrutoPosteriorFormatado = this.novoAjuste.ValorBrutoPosterior.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                this.calcularValorLiquidoFinal()
            },

            calcularValorLiquidoFinal(){
                if(this.patrimonio && this.patrimonio.configAmortizacao){
                    const valorLiquidoFinal = (this.novoAjuste.valorAcrescido || 0) + this.patrimonio.valorLiquido
                    this.novoAjuste.valorLiquidoFinal = valorLiquidoFinal
                    this.novoAjuste.valorLiquidoFinalFormatado = valorLiquidoFinal.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                }else if(this.patrimonio && !this.patrimonio.configAmortizacao){
                    const novoValorEntrada = this.novoAjuste.novoValorEntrada || 0
                    const valorLiquidoFinal = novoValorEntrada
                    this.novoAjuste.valorLiquidoFinal = valorLiquidoFinal
                    this.novoAjuste.valorLiquidoFinalFormatado = valorLiquidoFinal.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
                }
            },
            async salvarNovoAjuste() {
                const ajusteData = {
                    patrimonioId: this.$route.params.id,
                    tipo: this.novoAjuste.tipoAjuste,
                    observacao: this.novoAjuste.observacoes
                }

                if (this.novoAjuste.tipoAjuste === 'ADICAO_DE_CUSTO_SUBSEQUENTE') {
                    ajusteData.valorAcrescido = this.novoAjuste.valorAcrescido
                    ajusteData.valorLiquidoPosterior = this.novoAjuste.valorLiquidoFinal
                } else if (this.novoAjuste.tipoAjuste === 'REDUCAO_AO_VALOR_RECUPERAVEL') {
                    ajusteData.valorLiquidoPosterior = this.novoAjuste.valorLiquidoPosterior
                }

                await this.cadastrarNovoAjuste(ajusteData)
                this.fecharModalNovoAjuste()
            },

            atualizarTipoAjuste() {
                this.novoAjuste.valorAcrescido = null
                this.novoAjuste.valorLiquidoPosterior = null
                this.novoAjuste.valorLiquidoPosteriorFormatado = null
                this.novoAjuste.novoValorEntrada = null
                this.novoAjuste.valorLiquidoFinal = null
                this.novoAjuste.ValorBrutoPosterior = null
                this.novoAjuste.ValorBrutoPosteriorFormatado = null
                this.novoAjuste.valorLiquidoFinalFormatado = null
                this.novoAjuste.valorReduzido = null
                this.novoAjuste.valorReduzidoFormatado = null
                this.novoAjuste.valorBrutoPosterior = null
                this.novoAjuste.valorBrutoPosteriorFormatado = null

                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.resetValidation()
                    }
                })
            },


            atualizarNovoValorLiquidoInserido(value) {
                this.novoAjuste.valorLiquidoPosterior = value
                if (this.novoValorLiquidoValidado()) {
                    this.calcularValoresReducao()
                    return
                }

                this.novoAjuste.valorReduzido = null
                this.novoAjuste.valorReduzidoFormatado = null
                this.novoAjuste.valorBrutoPosterior = null
                this.novoAjuste.valorBrutoPosteriorFormatado = null

            },

            novoValorLiquidoValidado() {
                const valor = this.novoAjuste.valorLiquidoPosterior
                const liquidoAtual = this.patrimonio && this.patrimonio.valorLiquido != null
                    ? this.patrimonio.valorLiquido
                    : null

                if (typeof valor === 'number') {
                    if (valor < 0) return false
                    if (valor === 0) return false
                    if (liquidoAtual != null && valor > liquidoAtual) {
                        return false
                    }
                }

                return true
            },

            calcularValoresReducao(){
                if (this.patrimonio && this.patrimonio.valorLiquido !== undefined && this.patrimonio.valorBruto !== undefined) {

                    const valorReduzido = this.patrimonio.valorLiquido - this.novoAjuste.valorLiquidoPosterior
                    const valorBrutoPosterior = this.patrimonio.valorBruto - valorReduzido

                    const novoObjetoAjuste = {
                        ...this.novoAjuste,

                        valorLiquidoPosterior:this.novoAjuste.valorLiquidoPosterior,
                        valorLiquidoPosteriorFormatado: this.novoAjuste.valorLiquidoPosterior.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
                        valorReduzido: valorReduzido,
                        valorReduzidoFormatado: valorReduzido.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
                        valorBrutoPosterior: valorBrutoPosterior,
                        valorBrutoPosteriorFormatado: valorBrutoPosterior.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),

                    }

                    this.novoAjuste = novoObjetoAjuste

                }
            }


        }
    }
</script>

<style lang="stylus">
    .custom-error-message
        margin-top: -10px !important;

</style>
